import * as yup from 'yup';
import type { UserErrorMessages, UserValidation } from '../../../../types';
import { buildDateValidators } from './buildDateValidators';
import { buildObjectValidators } from './buildObjectValidators';
import { buildStringValidators } from './buildStringValidators';

const customFieldValueSchema = (validation: UserValidation) => {
  // infer which customField we are dealing with from validation
  if (validation.max || validation.min) {
    return buildDateValidators(validation);
  }
  return buildStringValidators(validation);
};

export const buildCustomFieldSchema = (
  { required, ...restValidation }: UserValidation,
  errorMessages?: UserErrorMessages
) => {
  const requiredText = required?.[0] ?? 'Invalid Custom Field';

  // Date schema
  if (restValidation.max || restValidation.min) {
    return buildObjectValidators({ required }, errorMessages).shape({
      value: customFieldValueSchema({ required, ...restValidation })
    });
  }

  return yup
    .mixed()
    .test('customField', restValidation.matches?.[1] ?? errorMessages?.value?.[0] ?? requiredText, (value) => {
      // If we have regex matches
      if (yup.string().isType(value?.value) && !!restValidation.matches) {
        const [regex, message] = restValidation.matches;
        return yup.string().matches(new RegExp(regex), message).isValidSync(value?.value);
      }

      // No regex - what about required? If so, then true if theres an object
      if (required) {
        const complexValue = value?.value || value?.values;
        if (yup.array().isType(complexValue)) {
          if ((complexValue as Array<any>).length > 0) {
            return yup.boolean().isValid(true);
          }
          return false;
        }
        return yup.string().nullable().isType(complexValue);
      }

      // If not required, then we're all good
      return yup.boolean().isValid(true);
    });
};
